<script>
import { doc, getDoc, getFirestore, updateDoc } from "firebase/firestore";
import _ from "lodash";
export default {
  name: "Booking",
  components: {
    UserCard: () => import("@/components/booking/userCard.vue"),
    Loader: () => import("@/components/Loader.vue"),
    ItemQualityDialog: () => import("../components/ItemQualityDialog.vue"),
    disclaimer: () => import("@/components/disclaimer.vue"),
    LinkPayVerify: () => import("@/components/LinkPayVerify.vue"),
    BookingFooter: () => import("@/components/booking/bookingFooter.vue"),
    LenderViewDto: () => import("@/components/booking/lenderViewDTO.vue"),
    BorrowerViewDto: () => import("@/components/booking/borrowerViewDTO.vue"),
    BookingHeader: () => import("@/components/booking/bookingHeader.vue"),
    ErrorCard: () => import("@/components/booking/errorCard.vue"),
    StatusImage: () => import("@/components/booking/statusImage.vue"),
    BookingFaq: () => import("@/components/booking/bookingFaq.vue"),
    acceptDecline: () => import("@/components/booking/acceptDecline.vue"),
    RatingDialog: () => import("@/components/RatingDialog.vue"),
    RatingItemDialog: () => import("@/components/RatingItemDialog.vue"),
    StatusBox: () => import("@/components/booking/statusBox.vue"),
  },
  data() {
    return {
      stitchDialog: false,
      errorMessage: "",
      booking: {},
      userCardUser: {},
      lenderView: false,
      borrowerView: false,
      errorMessage: "",
      cardUserId: "",
      happySwitch: false,
      returnedDialog: false,
      verified: false,
      verifyAcceptDialog: false,
      errorDialog: false,
      cardUser: {},
      startDate: "",
      verified: false,
      error: false,
      avatar: "",
      suburb: "",
      returnedDialog: false,
      happySwitch: false,
      paySnackbar: false,
      successDialog: false,
    };
  },

  methods: {
    refreshBooking() {
      this.booking = _.find(this.$store.getters.loadedUserBookings, {
        id: this.$route.params.id,
      });
    },
    completebooking() {
      this.booking.status = "complete";
    },
    returnedB() {
      this.booking.status = "returnedB";
    },
    paySuccess() {
      console.log("BOOKING PAY SUCCESS");

      //update booking in datas status to awaiting-images
      this.booking.status = "awaiting-images";
      this.$store.commit("setLoading", true);

      this.$store
        .dispatch("updateBookingData", {
          id: this.booking.id,
          status: "awaiting-images",
        })
        .then(() => {
          // this.paySnackbar = true;
          this.$store.commit("setLoading", false);
          this.successDialog = true;
        });
    },
    closeAcceptedDialog() {
      this.acceptedDialog = false;
      //set acceptDialog state in store to false
      this.$store.commit("setAcceptDialog", false);
      //refrresh the page
      // this.$router.go(0);
    },
    async approveReturn() {
      try {
        //set loading to true
        this.$store.commit("setLoading", true);
        await this.$store
          .dispatch("updateBookingData", {
            id: this.$route.params.id,
            status: "returned",
            updatedAt: new Date(),
          })
          .then(() => {
            this.returnedDialog = true;
            this.$store.commit("setLoading", false);
          });
      } catch (error) {
        const errorMessage = error.message;
        alert(errorMessage);
      }
    },
    clearError() {
      this.error = false;
      console.log("Are we trying to clear the error? or nah?");
      // set error in store to false
      this.$store.dispatch("clearError");
      this.$store.commit("clearError");

      this.errorMessage = "";
    },

    refresh() {
      this.$store.commit("clearReviewSuccess");
      this.booking = _.find(this.$store.getters.loadedUserBookings, {
        id: this.$route.params.id,
      });
      // this.booking.status = _.find(this.$store.getters.loadedUserBookings, {
      // id: this.$route.params.id,
      // });
    },
  },

  computed: {
    loading() {
      return this.$store.getters.loading;
    },
    storeError() {
      return this.$store.getters.error;
    },
    reviewSubmitted() {
      return this.$store.getters.reviewSuccess;
    },
    acceptedDialog() {
      return this.$store.state.acceptDialog;
    },
  },

  // mounted() {
  //   const auth = getAuth();
  // const user = auth.currentUser;
  // console.log('mounted user', user);
  // this.userId = user.uid;
  // },

  async mounted() {
    // this.$store.dispatch("loadUserBookings",  this.$store.getters.user.id);

    console.log("beforeCreate", this.$store.getters.loadedUserBookings);
    console.log("beforeCreate id", this.$route.params.id);

    var a = await _.find(this.$store.getters.loadedUserBookings, {
      id: this.$route.params.id,
    });

    console.log("a", a);

    // var a = await _.find(this.$store.getters.loadedBookings, {
    //   id: this.$route.params.id,
    // });

    // const auth = getAuth();

    //     var user = await auth.currentUser;

    // console.log('user', user)

    //get user id

    // const user = auth.currentUser;
    // console.log('user', user);
    // this.userId = user.uid;

    if (a !== undefined) {
      console.log("a", a);
      this.booking = a;

      console.log("booking", this.booking);

      const user = await this.$store.state.user;

      console.log("USER:", user);

      if (user == null) {
        {
          console.log("Not authorised");
          this.error = true;
          this.$store.commit("setLoading", false);
          //set store loading to false
          this.$store.dispatch("setloading", false);
          this.errorMessage =
            "You aren't authorised to view this booking.🤕 <br />You may need to login to view it. <br />Please contact Strapp support if you think this is a mistake";
        }
      }

      const userId = user.id;

      console.log(
        "userId, lenderId, borrowerID",
        userId,
        this.booking.lenderID,
        this.booking.borrowerID
      );

      if (userId === this.booking.lenderID) {
        console.log("user is lender");
        this.lenderView = true;
        this.cardUserId = this.booking.borrowerID;
        this.$store.commit("setLoading", false);
      } else if (userId === this.booking.borrowerID) {
        console.log("user is borrower");
        this.borrowerView = true;
        this.cardUserId = this.booking.lenderID;
        this.$store.commit("setLoading", false);
      } else if (
        this.userId !== this.booking.lenderID ||
        this.userId !== this.booking.borrowerID
      ) {
        this.error = true;
        this.$store.commit("setLoading", false);
        this.errorMessage =
          "You aren't authorised to view this booking.🤕 <br />You may need to login to view it. <br />Please contact Strapp support if you think this is a mistake";
      }

      console.log("LenderView=: ", this.lenderView);
      console.log("BorrowerView=: ", this.borrowerView);

      try {
        this.id = this.cardUserId;
        console.log("id: ", this.id);

        const db = getFirestore();
        const docRef = doc(db, "users", this.id);
        const docSnap = await getDoc(docRef);

        console.log("User card data:", docSnap.data());

        this.cardUser = docSnap.data();
        let d = this.cardUser.createdAt.seconds;
        var date = new Date(d * 1000).toString();
        date = date.substring(4, 15);
        this.startDate = date;
        this.suburb = this.cardUser.suburb;
        this.avatar =
          this.cardUser.avatar ||
          "https://firebasestorage.googleapis.com/v0/b/strapp-4e040.appspot.com/o/users%2Favatar.png?alt=media&token=40199a7c-62e9-40bc-9089-a7771aaedefe";
        this.verified = this.cardUser.verified;
        this.$store.commit("setLoading", false);
      } catch (error) {
        console.log("Error getting user:", error);
        this.$store.commit("setLoading", false);
      }
    } else if (a === undefined) {
      //set loading in store

      const db = getFirestore();
      const docRef = doc(db, "bookings", this.$route.params.id);
      const docSnap = await getDoc(docRef);

      console.log("docSnap", docSnap);
      console.log("Document data:", docSnap.data());
      // try {
      if (docSnap.data()) {
        this.booking = docSnap.data();

        //get logged in user id
        const user = await this.$store.getters.user;

        if (user == null) {
          {
            console.log("Not authorised");
            this.error = true;
            this.$store.commit("setLoading", false);
            this.errorMessage =
              "You aren't authorised to view this booking.🤕 <br />You may need to login to view it. <br />Please contact Strapp support if you think this is a mistake";
          }
        }

        const userId = user.id;

        console.log(
          "user , lenderID, borrowerID",
          userId,
          this.booking.lenderID,
          this.booking.borrowerID
        );

        if (userId === this.booking.lenderID) {
          console.log("user is lender");
          this.lenderView = true;
          this.cardUserId = this.booking.borrowerID;

          this.$store.commit("setLoading", false);
        } else if (userId === this.booking.borrowerID) {
          console.log("user is borrower");
          this.borrowerView = true;
          this.cardUserId = this.booking.lenderID;
          this.$store.commit("setLoading", false);
        } else if (
          this.userId !== this.booking.lenderID ||
          this.userId !== this.booking.borrowerID
        ) {
          console.log("Not authorised");
          this.error = true;
          this.$store.commit("setLoading", false);
          this.errorMessage =
            "You aren't authorised to view this booking.🤕 <br />You may need to login to view it. <br />Please contact Strapp support if you think this is a mistake";
        }

        try {
          this.id = this.cardUserId;
          console.log("id: ", this.id);

          const db = getFirestore();
          const docRef = doc(db, "users", this.id);
          const docSnap = await getDoc(docRef);

          console.log("User card data:", docSnap.data());

          this.cardUser = docSnap.data();
          let d = this.cardUser.createdAt.seconds;
          var date = new Date(d * 1000).toString();
          date = date.substring(4, 15);
          this.startDate = date;
          this.suburb = this.cardUser.suburb;
          this.avatar =
            this.cardUser.avatar ||
            "https://firebasestorage.googleapis.com/v0/b/strapp-4e040.appspot.com/o/users%2Favatar.png?alt=media&token=40199a7c-62e9-40bc-9089-a7771aaedefe";
          this.verified = this.cardUser.verified;
          this.$store.commit("setLoading", false);
        } catch (error) {
          console.log("Error getting user:", error);
          this.$store.commit("setLoading", false);
        }
      }
      if (!docSnap.data()) {
        console.log("No such document!");
        this.error = true;
        this.errorMessage =
          "We couldnt find that booking or you aren't authorised to view it.🤕 <br />You may need to login to view it or it may not exist. <br />Please contact Strapp support if you think this is a mistake";
        this.$store.commit("setLoading", false);
      }
    }
  },
};
</script>

<template>
  <div>
    <v-overlay v-if="loading">
      <Loader />
    </v-overlay>

    <v-snackbar v-model="paySnackbar" :timeout="timeout">
      Your payment was successful and the lender has been notified. 🎉 Feel free
      to contact the lender now to arrange pickup or delivery.

      <template v-slot:action="{ attrs }">
        <v-btn color="blue" text v-bind="attrs" @click="snackbar = false">
          Close
        </v-btn>
      </template>
    </v-snackbar>

    <v-dialog
      v-model="successDialog"
      max-width="450px"
      persistent
      transition="dialog-bottom-transition"
    >
      <template>
        <v-card style="border-radius: 12px !important" class="text-center">
          <v-card-title class="text-center black--text">
            <p class="my-3 ml-auto mr-auto">Woohoo!</p>
          </v-card-title>
          <v-divider></v-divider>
          <div class="grid">
            <v-img
              size="small"
              width="300px"
              height="300px"
              :src="require('@/assets/svgs/celebrate-1.svg')"
            ></v-img>
          </div>
          <v-card-text class="my-2">
            Your payment was successful and the lender has been notified. 🎉
            Feel free contact them to organise pickup or delivery.
          </v-card-text>

          <v-card-actions class="mt-n9">
            <v-col>
              <v-row class="my-3">
                <v-btn
                  block
                  class="btn white--text"
                  style="border-radius: 8px !important"
                  color="accent"
                  @click="successDialog = false"
                >
                  Continue
                </v-btn>
              </v-row>
            </v-col>
          </v-card-actions>
        </v-card>
      </template>
    </v-dialog>

    <v-dialog
      v-model="storeError"
      max-width="550px"
      style="border-radius: 16px"
    >
      <v-card scrollable>
        <div class="grid pt-12">
          <v-row>
            <v-card class="mr-5" style="border-radius: 12px">
              <base-img
                :src="require('@/assets/logos/icon1.svg')"
                class="mx-auto pa-6"
                contain
                width="12"
              />
            </v-card>
          </v-row>
          <v-divider></v-divider>
          <v-card-title class="text-body-2 text-center mt-4 text-wrap"
            >An error has occured. Please try again</v-card-title
          >

          <v-card-text class="text-caption text-center">
            {{ storeError }}
          </v-card-text>

          <hr />
        </div>
        <v-card-actions class="mt-n6">
          <v-btn large color="accent darken-1" text @click="clearError()">
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-if="reviewSubmitted"
      v-model="reviewSubmitted"
      persistent
      color="white"
      style="border-radius: 12px !important; overflow: hidden"
      width="550"
    >
      <v-card
        style="border-radius: 12px !important; overflow: hidden"
        class="pa-3 text-center"
      >
        <v-card-title class="text-center black--text">
          <v-icon small color="black" @click="refresh()">mdi-close</v-icon>
          <p class="my-3 ml-auto mr-auto">Review Submitted! 🥳</p>
        </v-card-title>
        <v-divider></v-divider>
        <v-row>
          <v-col cols="12">
            <p class="pa-6">
              <span class="text-subtitle-2 font-weight-bold"
                >Thank you for participating in the Strapp Community</span
              >
              <br /><br />
              We hope to continue providing you with the best service we can.
            </p>
          </v-col>
        </v-row>
        <div class="grid mt-n3">
          <v-btn class="appbutton mt-n3" @click="refresh()">Continue</v-btn>
        </div>
      </v-card>
    </v-dialog>

    <v-row v-else-if="error" class="grid">
      <error-card :errorMessage="this.errorMessage"></error-card>
    </v-row>

    <v-col
      cols="12"
      lg="10"
      xl="8"
      offset-xl="2"
      offset-lg="1"
      class="pa-3"
      v-if="(!loading && !error && !storeError) || this.reviewSubmitted"
    >
      <v-card elevation="8" style="border-radius: 12px">
        <booking-header
          :lenderView="lenderView"
          :borrowerView="borrowerView"
        ></booking-header>

        <v-col cols="12">
          <div class="pa-0 ma-0 pa-md-6 ma-md-2 ma-lg-0">
            <br />
            <p v-if="borrowerView" class="text-center text-h6 grid mt-n4 mb-4">
              {{ booking.itemName }}
            </p>
            <p v-if="lenderView" class="text-center text-h6 grid mt-n4 mb-10">
              Your {{ booking.itemName }}
            </p>
            <v-row class="justify-space-between">
              <v-col cols="12">
                <div
                  max-width="200px"
                  class="mx-auto"
                  style="border-radius: 13px"
                >
                  <v-row>
                    <status-image
                      :booking="booking"
                      :lenderView="lenderView"
                      :borrowerView="borrowerView"
                    ></status-image>

                    <v-col cols="12" sm="6" class="mt-n7">
                      <status-box
                        :booking="booking"
                        :cardUserId="cardUserId"
                        :borrowerView="borrowerView"
                        :lenderView="lenderView"
                        :cardUser="cardUser"
                      ></status-box>
                      <user-card
                        :booking="booking"
                        :cardUserId="cardUserId"
                        :borrowerView="borrowerView"
                        :lenderView="lenderView"
                        :cardUser="cardUser"
                        :startDate="startDate"
                        :avatar="avatar"
                        :verified="verified"
                        :suburb="suburb"
                      ></user-card>
                      <v-template
                        class="grid hidden-sm-and-down mt-n5"
                        v-if="booking.status == 'pending' && lenderView == true"
                      >
                        <accept-decline
                          :booking="booking"
                          v-if="
                            booking.status == 'pending' && lenderView == true
                          "
                        ></accept-decline>
                      </v-template>
                      <v-col
                        cols="12"
                        class="d-flex align-center grid mt-n3"
                        v-if="
                          (booking.status == 'awaiting-images' &&
                            lenderView == true) ||
                          (booking.status == 'finalised' && lenderView == true)
                        "
                      >
                        <v-row
                          class="mx-5"
                          v-if="booking.status === 'awaiting-images'"
                        >
                          <item-quality-dialog
                            :refreshBooking="refreshBooking()"
                            :booking="booking"
                          >
                          </item-quality-dialog>
                        </v-row>
                        <v-row
                          v-else-if="booking.status === 'finalised'"
                          class="text-center grid mt-6"
                          color="success"
                          style="justify-content: center"
                        >
                          <item-quality-dialog
                            :reUpload="true"
                            :booking="booking"
                          >
                          </item-quality-dialog>
                        </v-row>
                      </v-col>

                      <v-col
                        cols="12"
                        class="grid"
                        v-if="
                          booking.status == 'pending-return' &&
                          lenderView == true
                        "
                      >
                        <v-row justify="center" no-gutters>
                          <v-row class="grid">
                            <v-col class="grid">
                              <v-switch
                                class="black--text"
                                color="secondary"
                                v-model="happySwitch"
                                :label="
                                  happySwitch == true
                                    ? 'I am happy with my return'
                                    : 'I am happy with my return'
                                "
                              >
                              </v-switch>

                              <v-row class="grid">
                                <v-hover v-slot="{ hover }">
                                  <v-btn
                                    :disabled="!happySwitch"
                                    class="appbutton mx-1 mt-3 my-4 white--text font-weight-medium"
                                    :elevation="hover ? 16 : 4"
                                    :class="{ 'on-hover': hover }"
                                    color="accent"
                                    rounded
                                    @click="approveReturn()"
                                  >
                                    <v-img
                                      width="20px"
                                      height="20px"
                                      class="mr-3"
                                      :src="
                                        require('@/assets/fontawesome/check-duotone.svg')
                                      "
                                    />
                                    Confirm Return
                                  </v-btn>
                                </v-hover>
                              </v-row></v-col
                            >
                          </v-row>
                        </v-row>
                      </v-col>
                    </v-col>
                  </v-row>
                </div>
              </v-col>
            </v-row>

            <v-divider class="my-6"></v-divider>

            <v-row>
              <v-col
                class="my-8 hidden-sm-and-down"
                cols="12"
                md="12"
                v-if="
                  (booking.status == 'returned' && lenderView == true) ||
                  (booking.status == 'returnedB' && lenderView == true)
                "
              >
                <v-row class="grid">
                  <rating-dialog
                    class="center"
                    style="margin-top: 16px; align-items: center"
                    :booking="booking"
                    :showBtn="true"
                    :open="false"
                    @complete="completebooking()"
                    @returnedB="returnedL()"
                  >
                  </rating-dialog>
                </v-row>
              </v-col>

              <v-col
                cols="12"
                md="12"
                class="my-8 hidden-sm-and-down"
                v-if="
                  (booking.status == 'returned' && borrowerView == true) ||
                  (booking.status == 'returnedL' && borrowerView == true)
                "
              >
                <v-row class="grid">
                  <rating-item-dialog
                    class="center"
                    style="align-items: center"
                    :booking="booking"
                    :showBtn="true"
                    :open="false"
                    @complete="completebooking()"
                    @returnedB="returnedB()"
                  >
                  </rating-item-dialog>
                </v-row>
              </v-col>

              <v-col
                v-if="borrowerView"
                class="mb-n4"
                cols="12"
                md="6"
                offset-md="3"
              >
                <borrower-view-dto
                  @paySuccess="paySuccess()"
                  :booking="booking"
                ></borrower-view-dto>
              </v-col>

              <v-col
                v-if="lenderView"
                class="mb-n4"
                cols="12"
                md="6"
                offset-md="3"
              >
                <lender-view-dto :booking="booking"></lender-view-dto>
              </v-col>
            </v-row>
          </div>
        </v-col>

        <v-row class="grid my-5 mx-4">
          <disclaimer></disclaimer>
        </v-row>

        <booking-faq></booking-faq>
      </v-card>
    </v-col>

    <v-dialog
      style="border-radius: 12px !important; overflow: hidden"
      v-model="returnedDialog"
      width="550"
      persistent
    >
      <v-card
        style="border-radius: 12px !important; overflow: hidden"
        class="pa-3 text-center"
      >
        <v-card-title
          style="
            padding: 0px 24px !important;
            font-size: 1em !important;
            line-height: 1.43;
          "
          class="text-center black--text"
        >
          <!-- <v-icon small color="black" @click="acceptedDialog = false"
            >mdi-close</v-icon
          > -->
          <p class="my-3 ml-auto mr-auto">Item Returned! 🥳</p>
        </v-card-title>
        <v-divider></v-divider>
        <v-row>
          <v-col cols="12">
            <p class="pa-6">
              <span class="text-subtitle-1 font-weight-bold"
                >You have successfully completed this booking!</span
              >
              <br /><br />
              We would appreciate you taking the time to provide a rating and
              review on your lending experience. It goes a long way to improving
              the comunity trust on our platform. Thank you!
            </p>
          </v-col>
        </v-row>
        <div class="grid">
          <v-btn
            elevation="8"
            width="7rem"
            color="secondary"
            type="submit"
            value="Save Changes"
            class="ebtn"
            @click="
              refresh();
              returnedDialog = false;
            "
            >Continue</v-btn
          >
        </div>
      </v-card>
    </v-dialog>

    <v-dialog
      persistent
      style="border-radius: 12px !important; overflow: hidden"
      v-model="acceptedDialog"
      width="550"
    >
      <v-card
        style="border-radius: 12px !important; overflow: hidden"
        class="pa-3 text-center"
      >
        <v-card-title class="text-center black--text">
          <v-icon small color="black" @click="closeAcceptedDialog()"
            >mdi-close</v-icon
          >
          <p class="my-3 ml-auto mr-auto">Booking Accepted! 🥳</p>
        </v-card-title>
        <v-divider></v-divider>
        <v-row>
          <v-col cols="12">
            <p class="pa-6">
              <span class="text-subtitle-2 font-weight-bold"
                >You have successfully accepted this booking!</span
              >
              <br /><br />
              Once we have received payment from the borrower, we will send you
              a confirmation email. <br /><br />
              Until then this booking will have a status of 'Waiting for
              payment'
            </p>
          </v-col>
        </v-row>
        <div class="grid mt-n3">
          <v-btn class="appbutton mt-n3" @click="closeAcceptedDialog()"
            >Continue</v-btn
          >
        </div>
      </v-card>
    </v-dialog>

    <booking-footer
      @paySuccess="paySuccess()"
      v-if="
        booking.status == 'returned' ||
        (booking.status == 'returnedB' && lenderView == true) ||
        (booking.status == 'pending-return' && lenderView == true) ||
        (booking.status == 'awaiting-images' && lenderView == true) ||
        (booking.status == 'awaiting-payment' && borrowerView == true) ||
        (booking.status == 'pending' &&
          borrowerView == false &&
          !loading &&
          !error)
      "
      :booking="booking"
      :borrowerView="borrowerView"
      :lenderView="lenderView"
      :verified="verified"
    ></booking-footer>
  </div>
</template>

<style lang="scss" scoped>
.card-head {
  background-color: #b22af0;
  width: 100%;
  padding: 14px;
}

.card-bottom {
  background-color: #b22af0;
  width: 100%;
  padding: 8px;
  margin: 0px !important;
  padding-left: 0px !important;
  padding-right: 0px !important;
}

.line-heart4 {
  animation: line-heart4 3s linear infinite;
  stroke-dasharray: 100;
}
@keyframes line-heart4 {
  0% {
    stroke-dashoffset: 200;
  }
  50% {
    stroke-dashoffset: 0;
  }
  100% {
    stroke-dashoffset: -200;
  }
}
@media (prefers-reduced-motion: reduce) {
  .line-heart4 {
    animation: none;
  }
}
</style>
